import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGoogleAuth } from '../../hooks/useGoogleAuth';
import toast from 'react-hot-toast';

export const GoogleCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { handleCallback } = useGoogleAuth();
  const [processed, setProcessed] = useState(false);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (processed || processing) return; // Prevent multiple executions
    
    const processCallback = () => {
      setProcessing(true);
      console.log('🔄 Google OAuth callback page loaded');
      
      const code = searchParams.get('code');
      const error = searchParams.get('error');
      
      console.log('📋 OAuth parameters:', { 
        hasCode: !!code, 
        hasError: !!error,
        code: code?.substring(0, 20) + '...'
      });

      if (error) {
        console.error('❌ Google OAuth error:', error);
        toast.error('Google sign-in was cancelled or failed');
        navigate('/login');
        return;
      }

      if (!code) {
        console.error('❌ No authorization code received');
        toast.error('No authorization code received');
        navigate('/login');
        return;
      }

      console.log('✅ Authorization code received, processing with hook...');
      setProcessed(true);
      // Use the hook to handle the callback
      handleCallback(code);
    };

    // Only run once
    processCallback();
  }, []); // Empty dependency array

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Completing sign-in...
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Please wait while we complete your Google sign-in.
          </p>
        </div>
      </div>
    </div>
  );
};